import styled from "styled-components";
import { Row } from "../../../components/flex/styled";
import { useContext } from "react";
import { Context } from "../../../context/index";

export const HeroWrapper = styled("div")(() => {
  const { isMenuOpen } = useContext(Context);
  return {
    // Hero wrapper - overall container
    width: "80%",
    minHeight: "60vh",
    margin: "calc(var(--sectionMargin) * 2) auto",
    padding: "0 var(--pagePadding)",
    position: "relative",
    top: isMenuOpen ? "calc(var(--mobileNavLinks))" : "0",
    "@media screen and (min-width: 1024px)": {
      margin: "calc(var(--sectionMargin) * 3) auto",
    },
    "@media screen and (max-width: 1024px)": {
      width: "75%",
    },
    "@media screen and (max-width: 768px)": {
      width: "100%",
    },
  };
});

export const HeroContainer = styled(Row)(() => {
  return {
    // 50/50 split on desktop, stacked on mobile
    gap: "var(--flexGap)",
    alignItems: "center",
    "@media screen and (max-width: 1024px)": {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  };
});

export const HeroTextContent = styled("div")(() => {
  return {
    // Left side - text content
    flex: "1",
    display: "flex",
    flexDirection: "column",
    gap: "calc(var(--flexGap)/4)",
    "@media screen and (max-width: 1024px)": {
      order: 1, // text comes first on mobile
    },
  };
});

export const HeroImagePlaceholder = styled("div")(() => {
  return {
    // Right side - image placeholder
    flex: "1",
    minHeight: "400px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1rem",
    "& img": {
      width: "100%",
      borderRadius: "12px",
    },
    "@media screen and (max-width: 1024px)": {
      width: "100%",
      order: 2, // image comes after text on mobile
    },
  };
});

export const HeroButtonRow = styled(Row)(() => {
  return {
    gap: "var(--flexGap)",
    "& button": {
      fontSize: "1rem",
      padding: "calc(var(--cardPadding)/3) calc(var(--cardPadding)/1.5)",
      border: "2px solid transparent",
      transition: "transform 0.3s ease",
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      },
    },
    "@media screen and (max-width: 425px)": {
      flexDirection: "column",
      gap: "calc(var(--flexGap)/2)",
    },
  };
});
